import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { BreadcrumbService } from 'ng2-breadcrumb/ng2-breadcrumb';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { devModeEqual } from '@angular/core/src/change_detection/change_detection';
import * as ip from "ip";


@Component({
    selector: 'app-backupftp-dashboard',
    templateUrl: './vm-dashboard.component.html'
})

export class VMDashboardComponent implements OnInit {

    // Selected Subnet to modal
	public modalElements: any = { prefix: '127.0.0.1', prefix_len: 32, ipv4s: [] };
    // Metody biblioteki IP
	public ipMethods = ip;
    // Zmienna mówiąca o pobieraniu danych
    public loadingVMData: Boolean = true;
    public VMIsReady: Boolean = false;

    // Obiekt Cloud.VPS
    public vm: any;
    public uuid: String;
    public password: String;
    public serviceID: String | null = null;

    public mainSubnetIpv4: any | null = null;
    public powerStatus: String | null = null;
    public diskSize: String | null = null;
    public additionalDisks: any = {};
    public rrdCpu: String | null = null;
    public rrdRam: String | null = null;
    public rrdDisk: String | null = null;
    public rrdNet: String | null = null;

    public loginInformation: any | null = null;
    public checkingStatus: boolean = true;

    public isLoadingAccountData: boolean = true;
    public accountPassword: String;
    public accountLogin: String;
    public accountPubKey: String | null = null;
    public hasPubKey: boolean = false;

    public loadingIPs: boolean = true;
    public subnetIPv4s = [];

    p: number = 1;
    p2: number = 1;

    /**
     * Creates an instance of ServerDashboardComponent.
     * @param {ApiService} apiService 
     * @param {ActivatedRoute} router 
     * 
     * @memberOf BackupftpDashboardComponent
     */
    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private route: ActivatedRoute,
        private breadcrumbService: BreadcrumbService,
        private router: Router
    ) {
    }



    /**
     * Funkcja inicjalizujaca
     * 
     * 
     * @memberOf BackupftpDashboardComponent
     */
    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uuid = String(params['uuid']);
            this.getVPSInfo(this.uuid);
            this.getVPSIPv4Networks(this.uuid);
        });
    }

    private getVPSIPv4Networks(uuid: String): void {
        this.loadingIPs = true;
        this.apiService.get('/vm/' + uuid + '/ipv4').subscribe(
            (response) => {
                this.subnetIPv4s = this.responseService.success(false, response, 'subnets');
                this.loadingIPs = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }

    private getVPSInfo(uuid: String): void {
        this.loadingVMData = true;
        this.apiService.get('/vm/' + uuid).subscribe(
            (response) => {
                this.vm = this.responseService.success(false, response, 'vm');
                this.password = this.responseService.success(false, response, 'password');
                this.VMIsReady = this.vm.build_status == 'active' ? true : false;
                if(this.VMIsReady){
                    this.breadcrumbService.addFriendlyNameForRoute('/vm/' + uuid, this.vm.name);
                }
                this.serviceID = this.responseService.success(false, response, 'contract_service_uuid');
                this.mainSubnetIpv4 = this.responseService.success(false, response, 'main_subnet_ipv4');
                this.powerStatus = this.responseService.success(false, response, 'power_status');
                this.diskSize = this.responseService.success(false, response, 'disk_size');
                this.additionalDisks = this.responseService.success(false, response, 'additional_disks');
                this.rrdCpu = this.responseService.success(false, response, 'rrd_cpu');
                this.rrdRam = this.responseService.success(false, response, 'rrd_ram');
                this.rrdDisk = this.responseService.success(false, response, 'rrd_disk');
                this.rrdNet = this.responseService.success(false, response, 'rrd_net');
                this.loadingVMData = false;
                this.checkingStatus = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }

    private getConsoleLink()
    {
        this.apiService.get('/vm/' + this.uuid + '/link').subscribe(
            (response) => {
                let consoleLink = this.responseService.success(false, response, 'link');
                window.open(consoleLink, '_blank');
            },
            (error) => {
                this.responseService.error(error);
            }
        );
    }

    public goToBuyServices()
	{
		this.router.navigateByUrl('/service/offer?for_service=' + this.serviceID);
    }
    
    public newMessage() {
		this.router.navigateByUrl('messages/new?severity=1&service=' + this.serviceID);
    }
    
    public powerVM(type: String, modal: any): void {
        this.checkingStatus = true;

        this.apiService.get('/vm/' + this.uuid + '/power/' + type).subscribe(
            (response) => {
                this.powerStatus = this.responseService.success(true, response, 'power_status');
            },
            (error) => {
                this.responseService.error(error);
            }
        );

        this.checkingStatus = false;
		modal.close();
	}

    public refreshPowerStatus()
    {
        this.checkingStatus = true;

        this.apiService.get('/vm/' + this.uuid + '/power').subscribe(
            (response) => {
                this.powerStatus = this.responseService.success(true, response, 'power_status');
            },
            (error) => {
                this.responseService.error(error);
            }
        );

        this.checkingStatus = false;
    }

     /**
   * Pobranie hasła konta FTP
   * 
   * @private
   * @param {*} modal 
   * @memberof BackupftpDashboardComponent
   */
	private showLoginInformation(modal: any): void {
        this.isLoadingAccountData = true;
        this.accountPassword = '';
        this.accountLogin = this.vm.ciuser;
        this.accountPubKey  = null;
        this.hasPubKey = false;
        this.apiService.get('/vm/' + this.uuid + '/login').subscribe(
            (response) => {
                this.accountPassword = this.responseService.success(false, response, 'password');
                this.accountLogin = this.responseService.success(false, response, 'user');
                this.isLoadingAccountData = false;
            },
            (error) => {
                this.responseService.error(error);
            }
        );
		modal.open();
    }
    
    private getServerGateway(ips) {
		for (let ip of ips) {
			if (ip['ip_type'] === 'gateway') {
				return ip['ip_address'];
			}
		}
		return '';
	}

    private showIPS(subnet: any, modal: any) {
		this.modalElements = subnet;
		modal.open();
    }
    
    private getModalElements() {
		const ips = this.modalElements.ipv4s.filter(i => { return i.ip_type !== 'gateway'; });
		return ips;
	}
}



// WEBPACK FOOTER //
// ./src/app/vm/vm-dashboard.component.ts